const landingRouteTargets = {
  '/': {
    path: '/',
    sectionId: 'home',
    itemSection: 'home',
  },
  '/services': {
    path: '/services',
    sectionId: 'services',
    itemSection: 'services',
  },
  '/about': {
    path: '/about',
    sectionId: 'vision',
    itemSection: 'about',
  },
  '/contact': {
    path: '/contact',
    sectionId: 'connect',
    itemSection: 'connect',
  },
};

const landingPathByMenuItem = {
  home: '/',
  services: '/services',
  about: '/about',
  connect: '/contact',
};

export const landingRoutePaths = Object.keys(landingRouteTargets);

export const getLandingRouteTarget = (pathname) => (
  landingRouteTargets[pathname] ?? landingRouteTargets['/']
);

export const getLandingPathForMenuItem = (menuItemId) => (
  landingPathByMenuItem[menuItemId] ?? '/'
);

export const getLandingMenuSection = (sectionId, showcaseSectionIds = []) => {
  if (showcaseSectionIds.includes(sectionId)) {
    return 'home';
  }

  if (sectionId === 'services') {
    return 'services';
  }

  if (sectionId === 'vision' || sectionId === 'values' || sectionId === 'ecom' || sectionId === 'why') {
    return 'about';
  }

  if (sectionId === 'store') {
    return 'store';
  }

  return 'connect';
};